<template>
  <DataTable
    v-redirect-if-no-permission:VEHICLE_TYPE_MANAGEMENT
    :url="api.ACTIONS.VEHICLE_TYPE"
    :titles="titles"
    :fieldsHiddenMain="['deleted_at']"
    :fieldsHiddenAdd="['id', 'created_at', 'deleted_at', 'updated_at']"
    :fieldsDisabledEdit="['id', 'created_at', 'deleted_at', 'updated_at']"
    :title="$t('drivers.vehicleType.vehicleType')"
    :formatter="formatter"
    :fields-extra-add="extraEditor"
    :fields-extra-edit="extraEditor"
    :add-rules="rules(true)"
    :edit-rules="rules(false)"
    :fieldsExtraAdd="fieldsExtraAdd"
  />
</template>

<script>
import DataTable from "@/components/monaco/DataTable";
import moment from "moment";
import i18n from "@/i18n";

const number = (value) => {
  const pattern = /^\d+$/;
  if (!!value) return pattern.test(value) || i18n.t("drivers.vehicleType.mustBeNumber");
  else return true;
};
const required = (value) => !!value || i18n.t("common.required");

export default {
  name: "VehicleType",
  title() {
    return this.$t("drivers.vehicleType.title");
  },
  components: { DataTable },
  methods: {
    rules(add) {
      return {
        max_seats_number: [number],
        priority: add ? [required, number] : [number],
        name: add ? [required] : [],
        icon: add ? [required] : [],
      };
    },
  },
  computed: {
    titles() {
      return {
        id: "#",
        name: this.$t("common.name"),
        max_seats_number: this.$t("drivers.vehicleType.maxSeatsNumber"),
        created_at: this.$t("drivers.vehicleType.dateCreated"),
        updated_at: this.$t("drivers.vehicleType.dateUpdated"),
      };
    },
    extraEditor() {
      return {
        icon: "choose-image-single",
      };
    },
    formatter() {
      const api = this.api;
      const unloadable = this.$t("drivers.vehicleType.unloadable");
      return {
        icon(value) {
          if (value == null) return unloadable;

          if (value[0] !== "/") value = "/" + value;
          return `<img src="${
            api.IMAGES_URL + value
          }" style="max-width: 45px;max-height: 45px;" class="img-thumbnail"/>`;
        },
        created_at: (value) =>value != null ? moment(value).format("DD-MM-YYYY - HH:mm") : null,
        updated_at: (value) => moment(value).format("DD-MM-YYYY - HH:mm"),
      };
    },
    fieldsExtraAdd() {
      return {
        name: "v-text-field",
        icon: "choose-image-single",
      };
    },
  },
};
</script>

<style scoped>
.img-thumbnail {
  height: 40px;
  width: 40px;
}
</style>
